// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取STS临时token GET /vod/sts/token */
export async function vodStsTokenUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultStsTokenResp>('/vod/sts/token', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取播放凭证 GET /vod/video/auth */
export async function vodVideoAuthUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vodVideoAuthUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/vod/video/auth', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
